// Dog breeds data with size categories
// Data source: backend/data/dog_breeds_with_size.csv

export interface BreedData {
  name: string;
  sizeCategory: string;
}

export interface BreedCategory {
  name: string;
  description: string;
  breeds: BreedData[];
}

export const DOG_BREEDS: BreedData[] = [
  { name: "Affenpinscher", sizeCategory: "Toy-Small" },
  { name: "Afghan Hound", sizeCategory: "Medium-Large" },
  { name: "Airedale Terrier", sizeCategory: "Large" },
  { name: "Akita", sizeCategory: "Large-Giant" },
  { name: "Alaskan Klee Kai", sizeCategory: "Small-Medium" },
  { name: "Alaskan Malamute", sizeCategory: "Large-Giant" },
  { name: "American Bulldog", sizeCategory: "Large-Giant" },
  { name: "American English Coonhound", sizeCategory: "Medium-Large" },
  { name: "American Eskimo Dog", sizeCategory: "Small-Medium" },
  { name: "American Foxhound", sizeCategory: "Large" },
  { name: "American Hairless Terrier", sizeCategory: "Small-Medium" },
  { name: "American Leopard Hound", sizeCategory: "Large" },
  { name: "American Staffordshire Terrier", sizeCategory: "Medium-Large" },
  { name: "American Water Spaniel", sizeCategory: "Medium" },
  { name: "Anatolian Shepherd Dog", sizeCategory: "Large-Giant" },
  { name: "Appenzeller Sennenhund", sizeCategory: "Medium-Large" },
  { name: "Australian Cattle Dog", sizeCategory: "Medium" },
  { name: "Australian Kelpie", sizeCategory: "Medium" },
  { name: "Australian Shepherd", sizeCategory: "Medium-Large" },
  { name: "Australian Stumpy Tail Cattle Dog", sizeCategory: "Medium" },
  { name: "Australian Terrier", sizeCategory: "Small-Medium" },
  { name: "Azawakh", sizeCategory: "Medium" },
  { name: "Barbado da Terceira", sizeCategory: "Medium-Large" },
  { name: "Barbet", sizeCategory: "Medium-Large" },
  { name: "Basenji", sizeCategory: "Small-Medium" },
  { name: "Basset Fauve de Bretagne", sizeCategory: "Medium" },
  { name: "Basset Hound", sizeCategory: "Medium-Large" },
  { name: "Bavarian Mountain Scent Hound", sizeCategory: "Medium-Large" },
  { name: "Beagle", sizeCategory: "Small" },
  { name: "Bearded Collie", sizeCategory: "Medium-Large" },
  { name: "Beauceron", sizeCategory: "Large-Giant" },
  { name: "Bedlington Terrier", sizeCategory: "Small-Medium" },
  { name: "Belgian Laekenois", sizeCategory: "Large" },
  { name: "Belgian Malinois", sizeCategory: "Large" },
  { name: "Belgian Sheepdog", sizeCategory: "Large" },
  { name: "Belgian Tervuren", sizeCategory: "Large" },
  { name: "Bergamasco Sheepdog", sizeCategory: "Large-Giant" },
  { name: "Berger Picard", sizeCategory: "Large" },
  { name: "Bernese Mountain Dog", sizeCategory: "Large-Giant" },
  { name: "Bichon Frise", sizeCategory: "Small-Medium" },
  { name: "Biewer Terrier", sizeCategory: "Toy-Small" },
  { name: "Black Russian Terrier", sizeCategory: "Large-Giant" },
  { name: "Black and Tan Coonhound", sizeCategory: "Large-Giant" },
  { name: "Bloodhound", sizeCategory: "Large-Giant" },
  { name: "Blue Picardy Spaniel", sizeCategory: "Medium-Large" },
  { name: "Bluetick Coonhound", sizeCategory: "Large" },
  { name: "Boerboel", sizeCategory: "Large-Giant" },
  { name: "Bohemian Shepherd", sizeCategory: "Medium" },
  { name: "Bolognese", sizeCategory: "Toy-Small" },
  { name: "Border Collie", sizeCategory: "Medium" },
  { name: "Border Terrier", sizeCategory: "Small" },
  { name: "Borzoi", sizeCategory: "Large-Giant" },
  { name: "Boston Terrier", sizeCategory: "Small-Medium" },
  { name: "Bouvier des Ardennes", sizeCategory: "Large" },
  { name: "Bouvier des Flandres", sizeCategory: "Large-Giant" },
  { name: "Boxer", sizeCategory: "Medium" },
  { name: "Boykin Spaniel", sizeCategory: "Medium" },
  { name: "Bracco Italiano", sizeCategory: "Large-Giant" },
  { name: "Braque Francais Pyrenean", sizeCategory: "Medium" },
  { name: "Braque Saint-Germain", sizeCategory: "Medium" },
  { name: "Braque du Bourbonnais", sizeCategory: "Medium" },
  { name: "Brazilian Terrier", sizeCategory: "Small-Medium" },
  { name: "Briard", sizeCategory: "Large-Giant" },
  { name: "Brittany", sizeCategory: "Medium" },
  { name: "Broholmer", sizeCategory: "Large-Giant" },
  { name: "Brussels Griffon", sizeCategory: "Toy-Small" },
  { name: "Bull Terrier", sizeCategory: "Large" },
  { name: "Bulldog", sizeCategory: "Medium" },
  { name: "Bullmastiff", sizeCategory: "Large-Giant" },
  { name: "Cairn Terrier", sizeCategory: "Small" },
  { name: "Calupoh", sizeCategory: "Large-Giant" },
  { name: "Canaan Dog", sizeCategory: "Medium" },
  { name: "Canadian Eskimo Dog", sizeCategory: "Large-Giant" },
  { name: "Cane Corso", sizeCategory: "Large-Giant" },
  { name: "Cardigan Welsh Corgi", sizeCategory: "Medium" },
  { name: "Carolina Dog", sizeCategory: "Medium" },
  { name: "Catahoula Leopard Dog", sizeCategory: "Large-Giant" },
  { name: "Caucasian Shepherd Dog", sizeCategory: "Large-Giant" },
  { name: "Cavalier King Charles Spaniel", sizeCategory: "Small-Medium" },
  { name: "Central Asian Shepherd Dog", sizeCategory: "Large-Giant" },
  { name: "Cesky Terrier", sizeCategory: "Small-Medium" },
  { name: "Chesapeake Bay Retriever", sizeCategory: "Large" },
  { name: "Chihuahua", sizeCategory: "Toy-Small" },
  { name: "Chinese Crested", sizeCategory: "Small" },
  { name: "Chinese Shar-Pei", sizeCategory: "Medium-Large" },
  { name: "Chinook", sizeCategory: "Large-Giant" },
  { name: "Chow Chow", sizeCategory: "Medium-Large" },
  { name: "Cirneco dell'Etna", sizeCategory: "Small-Medium" },
  { name: "Clumber Spaniel", sizeCategory: "Large-Giant" },
  { name: "Cocker Spaniel", sizeCategory: "Medium" },
  { name: "Collie", sizeCategory: "Large" },
  { name: "Coton de Tulear", sizeCategory: "Small" },
  { name: "Croatian Sheepdog", sizeCategory: "Medium" },
  { name: "Curly-Coated Retriever", sizeCategory: "Large-Giant" },
  { name: "Czechoslovakian Vlciak", sizeCategory: "Medium-Large" },
  { name: "Dachshund", sizeCategory: "Small-Medium" },
  { name: "Dalmatian", sizeCategory: "Medium-Large" },
  { name: "Dandie Dinmont Terrier", sizeCategory: "Small-Medium" },
  { name: "Danish-Swedish Farmdog", sizeCategory: "Small-Medium" },
  { name: "Deutscher Wachtelhund", sizeCategory: "Medium" },
  { name: "Doberman Pinscher", sizeCategory: "Large-Giant" },
  { name: "Dogo Argentino", sizeCategory: "Large-Giant" },
  { name: "Dogue de Bordeaux", sizeCategory: "Large-Giant" },
  { name: "Drentsche Patrijshond", sizeCategory: "Large-Giant" },
  { name: "Drever", sizeCategory: "Medium" },
  { name: "Dutch Shepherd", sizeCategory: "Medium-Large" },
  { name: "English Cocker Spaniel", sizeCategory: "Medium" },
  { name: "English Foxhound", sizeCategory: "Large" },
  { name: "English Setter", sizeCategory: "Large" },
  { name: "English Springer Spaniel", sizeCategory: "Medium" },
  { name: "English Toy Spaniel", sizeCategory: "Small" },
  { name: "Entlebucher Mountain Dog", sizeCategory: "Medium-Large" },
  { name: "Estrela Mountain Dog", sizeCategory: "Large-Giant" },
  { name: "Eurasier", sizeCategory: "Medium-Large" },
  { name: "Field Spaniel", sizeCategory: "Medium" },
  { name: "Finnish Lapphund", sizeCategory: "Medium" },
  { name: "Finnish Spitz", sizeCategory: "Medium" },
  { name: "Flat-Coated Retriever", sizeCategory: "Large" },
  { name: "French Bulldog", sizeCategory: "Medium" },
  { name: "French Spaniel", sizeCategory: "Medium-Large" },
  { name: "German Longhaired Pointer", sizeCategory: "Large" },
  { name: "German Pinscher", sizeCategory: "Medium" },
  { name: "German Shepherd Dog", sizeCategory: "Large-Giant" },
  { name: "German Shorthaired Pointer", sizeCategory: "Medium-Large" },
  { name: "German Spitz", sizeCategory: "Medium" },
  { name: "German Wirehaired Pointer", sizeCategory: "Large" },
  { name: "Giant Schnauzer", sizeCategory: "Large-Giant" },
  { name: "Glen of Imaal Terrier", sizeCategory: "Medium" },
  { name: "Golden Retriever", sizeCategory: "Large" },
  { name: "Gordon Setter", sizeCategory: "Large" },
  { name: "Grand Basset Griffon Vendéen", sizeCategory: "Medium" },
  { name: "Great Dane", sizeCategory: "Large-Giant" },
  { name: "Great Pyrenees", sizeCategory: "Large-Giant" },
  { name: "Greater Swiss Mountain Dog", sizeCategory: "Large-Giant" },
  { name: "Greyhound", sizeCategory: "Large" },
  { name: "Hamiltonstovare", sizeCategory: "Medium-Large" },
  { name: "Hanoverian Scenthound", sizeCategory: "Large-Giant" },
  { name: "Harrier", sizeCategory: "Medium-Large" },
  { name: "Havanese", sizeCategory: "Small" },
  { name: "Hokkaido", sizeCategory: "Medium-Large" },
  { name: "Hovawart", sizeCategory: "Large-Giant" },
  { name: "Ibizan Hound", sizeCategory: "Medium" },
  { name: "Icelandic Sheepdog", sizeCategory: "Medium" },
  { name: "Irish Red and White Setter", sizeCategory: "Medium" },
  { name: "Irish Setter", sizeCategory: "Large" },
  { name: "Irish Terrier", sizeCategory: "Medium" },
  { name: "Irish Water Spaniel", sizeCategory: "Medium-Large" },
  { name: "Irish Wolfhound", sizeCategory: "Large-Giant" },
  { name: "Italian Greyhound", sizeCategory: "Small" },
  { name: "Jagdterrier", sizeCategory: "Small-Medium" },
  { name: "Japanese Akitainu", sizeCategory: "Large-Giant" },
  { name: "Japanese Chin", sizeCategory: "Toy-Small" },
  { name: "Japanese Spitz", sizeCategory: "Small-Medium" },
  { name: "Japanese Terrier", sizeCategory: "Small" },
  { name: "Kai Ken", sizeCategory: "Medium" },
  { name: "Karelian Bear Dog", sizeCategory: "Medium" },
  { name: "Keeshond", sizeCategory: "Medium" },
  { name: "Kerry Blue Terrier", sizeCategory: "Medium" },
  { name: "Kishu Ken", sizeCategory: "Medium" },
  { name: "Komondor", sizeCategory: "Large-Giant" },
  { name: "Korean Jindo Dog", sizeCategory: "Medium" },
  { name: "Kromfohrlander", sizeCategory: "Medium" },
  { name: "Kuvasz", sizeCategory: "Large-Giant" },
  { name: "Labrador Retriever", sizeCategory: "Large" },
  { name: "Lagotto Romagnolo", sizeCategory: "Medium" },
  { name: "Lakeland Terrier", sizeCategory: "Small-Medium" },
  { name: "Lancashire Heeler", sizeCategory: "Small" },
  { name: "Lapponian Herder", sizeCategory: "Large-Giant" },
  { name: "Large Munsterlander", sizeCategory: "Large" },
  { name: "Leonberger", sizeCategory: "Large-Giant" },
  { name: "Lhasa Apso", sizeCategory: "Small-Medium" },
  { name: "Löwchen", sizeCategory: "Small-Medium" },
  { name: "Maltese", sizeCategory: "Toy-Small" },
  { name: "Manchester Terrier (Standard)", sizeCategory: "Small-Medium" },
  { name: "Manchester Terrier (Toy)", sizeCategory: "Small" },
  { name: "Mastiff", sizeCategory: "Large-Giant" },
  { name: "Miniature American Shepherd", sizeCategory: "Medium" },
  { name: "Miniature Bull Terrier", sizeCategory: "Small-Medium" },
  { name: "Miniature Pinscher", sizeCategory: "Toy-Small" },
  { name: "Miniature Schnauzer", sizeCategory: "Small-Medium" },
  { name: "Mixed Breed", sizeCategory: "Variable" },
  { name: "Mountain Cur", sizeCategory: "Medium" },
  { name: "Mudi", sizeCategory: "Small-Medium" },
  { name: "Neapolitan Mastiff", sizeCategory: "Large-Giant" },
  { name: "Nederlandse Kooikerhondje", sizeCategory: "Medium" },
  { name: "Newfoundland", sizeCategory: "Large-Giant" },
  { name: "Norfolk Terrier", sizeCategory: "Small" },
  { name: "Norrbottenspets", sizeCategory: "Medium" },
  { name: "Norwegian Buhund", sizeCategory: "Medium" },
  { name: "Norwegian Elkhound", sizeCategory: "Medium-Large" },
  { name: "Norwegian Lundehund", sizeCategory: "Small-Medium" },
  { name: "Norwich Terrier", sizeCategory: "Small" },
  { name: "Nova Scotia Duck Tolling Retriever", sizeCategory: "Medium" },
  { name: "Old English Sheepdog", sizeCategory: "Large-Giant" },
  { name: "Otterhound", sizeCategory: "Large-Giant" },
  { name: "Papillon", sizeCategory: "Toy-Small" },
  { name: "Parson Russell Terrier", sizeCategory: "Small-Medium" },
  { name: "Pekingese", sizeCategory: "Small" },
  { name: "Pembroke Welsh Corgi", sizeCategory: "Medium" },
  { name: "Peruvian Inca Orchid", sizeCategory: "Toy-Small" },
  { name: "Petit Basset Griffon Vendéen", sizeCategory: "Medium" },
  { name: "Pharaoh Hound", sizeCategory: "Medium-Large" },
  { name: "Plott", sizeCategory: "Medium-Large" },
  { name: "Pointer", sizeCategory: "Large" },
  { name: "Polish Lowland Sheepdog", sizeCategory: "Medium" },
  { name: "Pomeranian", sizeCategory: "Toy-Small" },
  { name: "Pont-Audemer Spaniel", sizeCategory: "Medium" },
  { name: "Poodle (All Varities)", sizeCategory: "Medium" },
  { name: "Poodle (Miniature)", sizeCategory: "Small" },
  { name: "Poodle (Standard)", sizeCategory: "Medium-Large" },
  { name: "Poodle (Toy)", sizeCategory: "Toy-Small" },
  { name: "Porcelaine", sizeCategory: "Medium-Large" },
  { name: "Portuguese Podengo", sizeCategory: "Medium" },
  { name: "Portuguese Podengo Pequeno", sizeCategory: "Small" },
  { name: "Portuguese Pointer", sizeCategory: "Medium" },
  { name: "Portuguese Sheepdog", sizeCategory: "Medium" },
  { name: "Portuguese Water Dog", sizeCategory: "Medium" },
  { name: "Perro de Presa Canario", sizeCategory: "Large-Giant" },
  { name: "Pudelpointer", sizeCategory: "Medium-Large" },
  { name: "Pug", sizeCategory: "Small-Medium" },
  { name: "Puli", sizeCategory: "Medium" },
  { name: "Pumi", sizeCategory: "Medium" },
  { name: "Pyrenean Mastiff", sizeCategory: "Large-Giant" },
  { name: "Pyrenean Shepherd", sizeCategory: "Small-Medium" },
  { name: "Rafeiro do Alentejo", sizeCategory: "Large-Giant" },
  { name: "Rat Terrier", sizeCategory: "Small-Medium" },
  { name: "Redbone Coonhound", sizeCategory: "Medium-Large" },
  { name: "Rhodesian Ridgeback", sizeCategory: "Large-Giant" },
  { name: "Romanian Carpathian Shepherd", sizeCategory: "Large-Giant" },
  { name: "Romanian Mioritic Shepherd Dog", sizeCategory: "Large-Giant" },
  { name: "Rottweiler", sizeCategory: "Large-Giant" },
  { name: "Russell Terrier", sizeCategory: "Small" },
  { name: "Russian Toy", sizeCategory: "Toy-Small" },
  { name: "Russian Tsvetnaya Bolonka", sizeCategory: "Toy-Small" },
  { name: "Saint Bernard", sizeCategory: "Large-Giant" },
  { name: "Saluki", sizeCategory: "Medium-Large" },
  { name: "Samoyed", sizeCategory: "Medium-Large" },
  { name: "Schapendoes", sizeCategory: "Medium" },
  { name: "Schipperke", sizeCategory: "Small" },
  { name: "Scottish Deerhound", sizeCategory: "Large-Giant" },
  { name: "Scottish Terrier", sizeCategory: "Small-Medium" },
  { name: "Sealyham Terrier", sizeCategory: "Small-Medium" },
  { name: "Segugio Italiano", sizeCategory: "Medium-Large" },
  { name: "Shetland Sheepdog", sizeCategory: "Small-Medium" },
  { name: "Shiba Inu", sizeCategory: "Small-Medium" },
  { name: "Shih Tzu", sizeCategory: "Small" },
  { name: "Shikoku", sizeCategory: "Medium" },
  { name: "Siberian Husky", sizeCategory: "Medium" },
  { name: "Silky Terrier", sizeCategory: "Small" },
  { name: "Skye Terrier", sizeCategory: "Medium" },
  { name: "Sloughi", sizeCategory: "Medium-Large" },
  { name: "Slovakian Wirehaired Pointer", sizeCategory: "Medium-Large" },
  { name: "Slovensky Cuvac", sizeCategory: "Large-Giant" },
  { name: "Slovensky Kopov", sizeCategory: "Medium" },
  { name: "Small Munsterlander", sizeCategory: "Medium-Large" },
  { name: "Smooth Fox Terrier", sizeCategory: "Small-Medium" },
  { name: "Soft Coated Wheaten Terrier", sizeCategory: "Medium" },
  { name: "Spanish Mastiff", sizeCategory: "Large-Giant" },
  { name: "Spanish Water Dog", sizeCategory: "Medium" },
  { name: "Spinone Italiano", sizeCategory: "Medium" },
  { name: "Stabyhoun", sizeCategory: "Medium-Large" },
  { name: "Staffordshire Bull Terrier", sizeCategory: "Medium" },
  { name: "Standard Schnauzer", sizeCategory: "Medium" },
  { name: "Sussex Spaniel", sizeCategory: "Medium" },
  { name: "Swedish Lapphund", sizeCategory: "Medium" },
  { name: "Swedish Vallhund", sizeCategory: "Medium" },
  { name: "Taiwan Dog", sizeCategory: "Medium" },
  { name: "Teddy Roosevelt Terrier", sizeCategory: "Small-Medium" },
  { name: "Thai Bangkaew", sizeCategory: "Medium" },
  { name: "Thai Ridgeback", sizeCategory: "Medium-Large" },
  { name: "Tibetan Mastiff", sizeCategory: "Large-Giant" },
  { name: "Tibetan Spaniel", sizeCategory: "Small" },
  { name: "Tibetan Terrier", sizeCategory: "Small-Medium" },
  { name: "Tornjak", sizeCategory: "Large-Giant" },
  { name: "Tosa", sizeCategory: "Large-Giant" },
  { name: "Toy Fox Terrier", sizeCategory: "Toy-Small" },
  { name: "Transylvanian Hound", sizeCategory: "Medium-Large" },
  { name: "Treeing Tennessee Brindle", sizeCategory: "Medium" },
  { name: "Treeing Walker Coonhound", sizeCategory: "Large" },
  { name: "Vizsla", sizeCategory: "Medium-Large" },
  { name: "Volpino Italiano", sizeCategory: "Small" },
  { name: "Weimaraner", sizeCategory: "Large-Giant" },
  { name: "Welsh Springer Spaniel", sizeCategory: "Medium" },
  { name: "Welsh Terrier", sizeCategory: "Small-Medium" },
  { name: "West Highland White Terrier", sizeCategory: "Small-Medium" },
  { name: "Wetterhoun", sizeCategory: "Large" },
  { name: "Whippet", sizeCategory: "Medium" },
  { name: "Wire Fox Terrier", sizeCategory: "Small-Medium" },
  { name: "Wirehaired Pointing Griffon", sizeCategory: "Medium-Large" },
  { name: "Wirehaired Vizsla", sizeCategory: "Medium-Large" },
  { name: "Working Kelpie", sizeCategory: "Medium" },
  { name: "Xoloitzcuintli", sizeCategory: "Medium" },
  { name: "Yakutian Laika", sizeCategory: "Medium" },
  { name: "Yorkshire Terrier", sizeCategory: "Toy-Small" }
];

// Search function for breed dropdown
export const searchBreeds = (query: string): BreedData[] => {
  if (!query) return DOG_BREEDS;
  
  const lowerQuery = query.toLowerCase();
  return DOG_BREEDS.filter(breed => 
    breed.name.toLowerCase().includes(lowerQuery)
  );
};

// Get size category for a breed
export const getBreedSize = (breedName: string): string | null => {
  const breed = DOG_BREEDS.find(b => b.name.toLowerCase() === breedName.toLowerCase());
  return breed ? breed.sizeCategory : null;
};

// Create breed categories for organized selection
export const getBreedCategories = (): BreedCategory[] => {
  const categories: BreedCategory[] = [
    {
      name: "Toy & Small",
      description: "Under 25 lbs",
      breeds: []
    },
    {
      name: "Medium", 
      description: "25-60 lbs",
      breeds: []
    },
    {
      name: "Large",
      description: "60-90 lbs", 
      breeds: []
    },
    {
      name: "Giant",
      description: "90+ lbs",
      breeds: []
    },
    {
      name: "Mixed Breed",
      description: "Mixed or unknown breed",
      breeds: []
    }
  ];

  // Categorize breeds by size
  DOG_BREEDS.forEach(breed => {
    if (breed.sizeCategory === "Toy-Small" || breed.sizeCategory === "Small") {
      categories[0].breeds.push(breed);
    } else if (breed.sizeCategory === "Small-Medium" || breed.sizeCategory === "Medium") {
      categories[1].breeds.push(breed);
    } else if (breed.sizeCategory === "Medium-Large" || breed.sizeCategory === "Large") {
      categories[2].breeds.push(breed);
    } else if (breed.sizeCategory === "Large-Giant") {
      categories[3].breeds.push(breed);
    } else if (breed.name.includes("Mix") || breed.name.includes("Doodle") || breed.name.includes("Poo")) {
      categories[4].breeds.push(breed);
    } else {
      // Default to appropriate size category
      if (breed.sizeCategory.includes("Small")) categories[0].breeds.push(breed);
      else if (breed.sizeCategory.includes("Medium")) categories[1].breeds.push(breed);
      else if (breed.sizeCategory.includes("Large")) categories[2].breeds.push(breed);
      else categories[3].breeds.push(breed);
    }
  });

  // Add common designer breeds to Mixed category if not already there
  // Note: "Mixed Breed" already exists in DOG_BREEDS with sizeCategory "Variable"
  const designerBreeds = [
    { name: "Labradoodle", sizeCategory: "Medium-Large" },
    { name: "Goldendoodle", sizeCategory: "Medium-Large" },
    { name: "Bernedoodle", sizeCategory: "Large" },
    { name: "Saint Berdoodle", sizeCategory: "Large-Giant" },
    { name: "Schnoodle", sizeCategory: "Small-Medium" },
    { name: "Yorkipoo", sizeCategory: "Toy-Small" },
    { name: "Cockapoo", sizeCategory: "Small-Medium" },
    { name: "Maltipoo", sizeCategory: "Toy-Small" }
  ];

  designerBreeds.forEach(designerBreed => {
    if (!DOG_BREEDS.find(b => b.name === designerBreed.name)) {
      categories[4].breeds.push(designerBreed);
    }
  });
  
  // Add Mixed Breed from DOG_BREEDS if not already present
  const mixedBreed = DOG_BREEDS.find(b => b.name === "Mixed Breed");
  if (mixedBreed && !categories[4].breeds.find(b => b.name === "Mixed Breed")) {
      categories[4].breeds.push(mixedBreed);
    }

  // Sort breeds within each category alphabetically
  categories.forEach(category => {
    category.breeds.sort((a, b) => a.name.localeCompare(b.name));
  });

  return categories;
};

// Search within a specific category
export const searchBreedsInCategory = (query: string, category: BreedCategory): BreedData[] => {
  if (!query) return category.breeds;
  
  const lowerQuery = query.toLowerCase();
  return category.breeds.filter(breed => 
    breed.name.toLowerCase().includes(lowerQuery)
  );
};

